import { openBlock, createElementBlock, createStaticVNode } from "vue";
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-toilets-icon"
};
const _hoisted_1 = {
  width: "15",
  height: "16",
  viewBox: "0 0 15 16",
  fill: "currentColor",
  stroke: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createStaticVNode('<g clip-path="url(#clip0_3154_595)"><path opacity="0.4" d="M14.2778 0H1.27783C1.00439 0 0.777832 0.226562 0.777832 0.5V1C0.777832 1.27344 1.00439 1.5 1.27783 1.5H14.2778C14.5513 1.5 14.7778 1.27344 14.7778 1V0.5C14.7778 0.226562 14.5513 0 14.2778 0ZM5.52783 2.5H4.02783C3.89111 2.5 3.77783 2.61328 3.77783 2.75V3.25C3.77783 3.38672 3.89111 3.5 4.02783 3.5H5.52783C5.66455 3.5 5.77783 3.38672 5.77783 3.25V2.75C5.77783 2.61328 5.66455 2.5 5.52783 2.5Z"></path><path d="M14.7778 8C14.7778 7.43641 14.4086 6.911 13.7778 6.46056V1.5H1.77783V6.46056C1.14708 6.911 0.777832 7.43641 0.777832 8C0.777832 9.90575 1.81768 11.6005 3.43402 12.6997L2.82177 14.7109C2.62646 15.3516 3.10693 16 3.7788 16H11.7769C12.4487 16 12.9292 15.3516 12.7339 14.7109L12.1216 12.6997C13.738 11.6005 14.7778 9.90575 14.7778 8ZM3.77783 2.75C3.77783 2.61328 3.89111 2.5 4.02783 2.5H5.52783C5.66455 2.5 5.77783 2.61328 5.77783 2.75V3.25C5.77783 3.38672 5.66455 3.5 5.52783 3.5H4.02783C3.89111 3.5 3.77783 3.38672 3.77783 3.25V2.75ZM7.77783 9C5.01643 9 2.77783 8.55225 2.77783 8C2.77783 7.44769 5.01643 7 7.77783 7C10.5392 7 12.7778 7.44769 12.7778 8C12.7778 8.55225 10.5392 9 7.77783 9Z"></path></g><defs><clipPath id="clip0_3154_595"><rect width="14" height="16" fill="white" transform="translate(0.777832)"></rect></clipPath></defs>', 2);
const _hoisted_4 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
const uikitToiletsIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export {
  uikitToiletsIcon as default
};
//# sourceMappingURL=uikit-toilets-icon.vue.es.js.map
